module.exports = __webpack_public_path__ + "img/reward-success-emoji.99534587.png";